export default function TrustBar() {
  const trustItems = [
    { icon: 'ri-search-eye-line', label: 'Product Research' },
    { icon: 'ri-shopping-bag-3-line', label: 'Shopping Guides' },
    { icon: 'ri-ship-line', label: 'Shipping Info' },
    { icon: 'ri-shield-check-line', label: 'QC Knowledge' },
    { icon: 'ri-coupon-3-line', label: 'Discount Updates' },
    { icon: 'ri-shield-user-line', label: 'Safety Education' },
  ];

  return (
    <section className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-5">
        <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wide text-center mb-3">
          Trusted Resource For
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-sm text-foreground-700">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-accent-500`}></i>
              </div>
              <span className="whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}